import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  createDesignatedPerson,
  getAllDesignatedPersons,
  updateDesignatedPerson,
  deleteDesignatedPerson,
} from "../api/designatedPersons";

export function useGetDesignatedPersons() {
  return useQuery({
    queryKey: ["designatedPersons"],
    queryFn: getAllDesignatedPersons,
  });
}

export function useCreateDesignatedPerson() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "createDesignatedPerson",
    mutationFn: createDesignatedPerson,
    onSuccess: () => {
      queryClient.invalidateQueries(["designatedPersons"]);
    },
  });
}

export function useUpdateDesignatedPerson() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "updateDesignatedPerson",
    mutationFn: updateDesignatedPerson,
    onSuccess: () => {
      queryClient.invalidateQueries(["designatedPersons"]);
    },
  });
}

export function useDeleteDesignatedPerson() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "deleteDesignatedPerson",
    mutationFn: deleteDesignatedPerson,
    onSuccess: () => {
      queryClient.invalidateQueries(["designatedPersons"]);
    },
  });
}
